﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catTiposRequisitos } from "../Categorias y Estados/catTiposRequisitos";

const columns = () =>
(
    {
        c_requisito_id: new EntityColumn<string>({ name: 'c_requisito_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Requisito Id' }),
        vc_descripcion: new EntityColumn<string>({ name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción' }),
        c_tiporequisito_id: new EntityColumn<string>({ name: 'c_tiporequisito_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tipo de Requisito' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        requ_brwStandard: { name: 'requ_brwStandard', keyMappings: { c_requisito_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'TiposRequisitos': {
            name: 'TiposRequisitos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposRequisitos(client, parentKeys)
        }
    }
)

export class RequisitosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Requisitos');
    }
}